const DEPARTMENTS = [
  "ТРАВМАТОЛОГИЯ",
  "НЕЙРОХИРУРГИЯ",
  "I ХИРУРГИЯ",
  "II ХИРУРГИЯ",
  "УРОЛОГИЯ",
  "ОЖОГОВОЕ",
  "НЕВРОЛОГИЯ",
  "КАРДИОЛОГИЯ",
  "2 КАРДИОЛОГИЯ",
  "ГИНЕКОЛОГИЯ",
  "ТОКСИКОЛОГИЯ",
  "1 ТЕРАПИЯ",
  "2 ТЕРАПИЯ",
  "РЕАН. ЗАЛ",
  "ВСЕ ОТДЕЛЕНИЯ",
] as const;

export default DEPARTMENTS;
